'use client';

import { useEffect } from 'react';
import { getEnvironment } from '../utils/environment';

const DEV_SCRIPT_ID = '0197b1ee-f20f-7636-844a-7ca853be500b';
const STAGE_SCRIPT_ID = '01979d30-0088-7d66-9af2-3eb60ec7d01a';
const PROD_SCRIPT_ID = '0197d0e5-e50a-7712-bf6d-dc1f28f45e59';

function getDomainScriptId() {
    switch (getEnvironment()) {
        case 'dev':
            return DEV_SCRIPT_ID;
        case 'stage':
            return STAGE_SCRIPT_ID;
        case 'prod':
            return PROD_SCRIPT_ID;
        default:
            return PROD_SCRIPT_ID; // local / fallback
    }
}

declare global {
    interface Window {
        OneTrust?: {
            Init: () => void;
            LoadBanner: () => void;
            ToggleInfoDisplay: () => void;
        };
    }
}

export default function OneTrust() {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.setAttribute('data-domain-script', getDomainScriptId());
        script.onload = () => {
            window.OneTrust?.Init?.();
            window.OneTrust?.LoadBanner?.();
        };
        document.head.appendChild(script);
        return () => {
            script.remove();
        };
    }, []);

    return null;
}
